// extracted by mini-css-extract-plugin
export default {"body":"Oui_body__Turnk"};